// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import store from './store'
import router from './router'
import i18n from './lang' // Internationalization

import './plugin/fontawesome'
import './plugin/vue-unicons'
import './plugin/vue-lodash'
import './plugin/vue-moment'
import './plugin/element-ui'
import './plugin/v-media-query'
import './plugin/vue-localstorage'

import './permission' // permission control
import './styles/default.scss'

import * as filters from './filters' // global filters

Vue.config.productionTip = false

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js